import styled from 'styled-components/macro';

export const Header = styled.header`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
`;
